import {
  VersicherungsangabenConfig,
  VersicherungsangabenSectionConfig,
} from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';
import { resMitversicherterPartnerSchema } from '@/features/Sparten/res/schema/mitversicherterPartnerSchema/mitversicherterPartnerSchema';
import { mitversicherterPartnerInformationFormConfig } from '@/features/Sparten/res/formConfigs/mitversicherterPartnerInformationFormConfig';

const inputConfig: VersicherungsangabenSectionConfig = {
  [SECTION.INPUT_VN]: {
    label: 'Angaben zum Versicherungsnehmer / versicherte Person',
    component: () =>
      import(
        '@/features/Sparten/res/sections/input/InputVersicherungsnehmer.vue'
      ),
  },
  [SECTION.INPUT_ABSICHERUNG]: {
    label: 'Gewünschte Absicherung',
    component: () =>
      import('@/features/Sparten/res/sections/input/InputAbsicherung.vue'),
  },
  [SECTION.INPUT_BEITRAGSREDUZIERUNG]: {
    label: 'Mögliche Beitragsreduzierung',
    disabledPaths: ['demvRabattiert'],
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/input/InputBeitragsreduzierung.vue'
      ),
  },
};

const contractConfig: VersicherungsangabenSectionConfig = {
  [SECTION.CONTRACT_CLIENT]: {
    label: 'Persönliche Angaben',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
      ),
  },
  [SECTION.CONTRACT_MVP]: {
    label: 'Mitversicherter Partner',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractMitversicherterPartner.vue'
      ),
    componentProps: {
      mvpValidationSchema: resMitversicherterPartnerSchema,
      mitversicherterPartnerInformationFormConfig:
        mitversicherterPartnerInformationFormConfig,
    },
  },
  // [SECTION.CONTRACT_COMPANY_QUESTION]: {
  //   label: 'Gesellschaftsfragen',
  //   requiresContractTariff: true,
  //   component: () =>
  //     import(
  //       '@/features/Sparten/shared/sections/property/contract/ContractCompanyQuestions.vue'
  //     ),
  // },
  [SECTION.CONTRACT_ADDITIONAL_INFORMATION]: {
    label: 'Zusätzliche Angaben',
    component: () =>
      import(
        '@/features/Sparten/res/sections/contract/ContractAdditionalInformation.vue'
      ),
  },
  [SECTION.PROPERTY_CONTRACT_PREVIOUS_INSURANCE]: {
    label: 'Vorversicherung',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractPreviousInsuranceAndDamage.vue'
      ),
  },
  [SECTION.CONTRACT_BANK_TRANSFER_INFORMATION]: {
    label: 'Zahlungsinformation',
    requiresContractTariff: true,
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractBankTransferInformation.vue'
      ),
  },
};

export const resVersicherungsangabenConfig: VersicherungsangabenConfig = {
  inputConfig,
  contractConfig,
};
